import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "list-group" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]

import type { DiscreteScaleLevel } from '@Scales/Model'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyVoteEditor',
  props: {
    Comment: {},
    Value: {},
    HasAnswer: { type: Boolean },
    HasScale: { type: Boolean },
    ScaleLevels: {}
  },
  emits: ["update-comment", "update-value"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- actions ----------------

    function setComment(comment: string | null)
    {
        emit('update-comment', comment)
    }

    function setDirectValue(val: any)
    {
        const value = parseFloat(val)
        emit('update-value', value)
    }

    function setScaleValue(sl: DiscreteScaleLevel)
    {
        const value = isSelected(sl) ? null : sl.Value
        emit('update-value', value)
    }

    function isSelected(sl: DiscreteScaleLevel): boolean
    {
        return props.Value === sl.Value
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.HasScale)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ScaleLevels, (sl) => {
              return (_openBlock(), _createElementBlock("button", {
                onClick: ($event: any) => (setScaleValue(sl)),
                class: _normalizeClass(["list-group-item list-group-item-action text-left", {'active': isSelected(sl)}])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa", [isSelected(sl) ? 'fa-check-circle' : 'fa-circle-thin' ]])
                }, null, 2 /* CLASS */),
                _createTextVNode(" " + _toDisplayString(sl.Name) + " (" + _toDisplayString(sl.Value) + ") ", 1 /* TEXT */),
                (sl.Definition)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(sl.Definition), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 10 /* CLASS, PROPS */, _hoisted_3))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("textarea", {
            rows: "3",
            value: __props.Comment,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (setComment($event.target.value))),
            class: "form-control my-3",
            placeholder: "Comment..."
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
          (!__props.HasAnswer)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setComment('Skipped')))
              }, " Skip (don't guess) "))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (!__props.HasScale)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("input", {
            type: "number",
            value: __props.Value,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (setDirectValue($event.target.value))),
            class: "form-control"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7),
          _createElementVNode("textarea", {
            rows: "3",
            value: __props.Comment,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (setComment($event.target.value))),
            class: "form-control my-3",
            placeholder: "Comment..."
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8),
          (!__props.HasAnswer)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (setComment('Skipped')))
              }, " Skip (don't guess) "))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})